<template>
    <el-dialog class="toast" :visible="isOpen" :show-close="false">
        <div slot="title" class="jumFpeedback_head">
            <img src="../assets/images/login/logo.png" alt="">
            <b></b>
            <span>授权</span>
        </div>
        <div class="jumpFeedback_body">
            <div class="title">
                <span class="blod">瑞网青年导演大赛</span>火热进行中,请参与投票或报名参赛
            </div>
            <div class="user">
               <el-input :value="userData.mobile" :disabled="true"></el-input>
            </div>
            <div class="code">
                <el-input v-model="code" placeholder="请输入验证码"></el-input>
                <el-button type="primary" @click="btnTimeFn">{{isClickBtn ? `重新发送${time}s` : '获取验证码' }}</el-button>
            </div>
            <div class="regType">
                <el-select v-model="userType" placeholder="请选择您的用户类型" size="medium" >
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        <span style="float: left">{{ item.label }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.text }}</span>
                    </el-option>
                </el-select>
            </div>
            <div class="loginBtn" @click="regDealFn">
                <span>确认</span>
            </div>
        </div>
    </el-dialog>
</template>

<script>
  import { Message } from 'element-ui'
  export default {
    name: 'regBridge',
    props: ['isOpen', 'userData' ],
    data() {
      return {
        options:[{
          value: 2,
          label: '参赛者',
          text: '可上传作品、可观看、无法投票'
        },{
          value: 3,
          label: '普通用户',
          text: '无法上传作品、可观看、可投票'
        }],
        code: '',
        isClickBtn: false,
        time: 60,
        userType: ''
      }
    },
    methods: {
      btnTimeFn () {
        if (!this.isClickBtn) {
          this.isClickBtn = true
          this.$emit('sendCode')
          var interval = setInterval(() =>{
            this.time = this.time - 1
            if(this.time == 0) {
              clearInterval(interval)
              this.time = 60
              this.isClickBtn = false
            }
          },1000)
        }
      },
      regDealFn () {
        if (!this.code || !this.userType) {
            this.$message({
              message: '请完善信息',
              type: 'warn'
            })
        } else {
          this.$emit('regDeal', {
            code: this.code,
            userType: this.userType
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    iframe {
        width: 0;
        height: 0;
        border: 0;
    }
    .blod {
        font-weight: bold;
        color: #000;
        line-height: 40px;
    }
    .el-dialog {
        width: 30%;
    }
    .el-select {
        width: 100%;
    }
    .jumFpeedback_head {
        display: flex;
        align-items: center;
        b {
            width: 4px;
            height: 4px;
            margin: 0 10px;
            background-color: #3bc0d0;
            border-radius: 50%;
            display: inline-block;
        }
        span {
            font-size: 18px;
            color: #3bc0d0;
        }
        img {
            margin-top: 0;
        }
    }
    .jumpFeedback_body {
        width: 100%;
        padding: 20px 61px 30px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        .user {
            width: 100%;
            height: 55px;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            input {
                width: 90%;
                height: 30px;
                border: none;
                outline: none;
                font-size: 16px;
                &::-webkit-input-placeholder {
                    color: #ccc;
                }
                &::-moz-placeholder {
                    color: #ccc;
                }
                &::-ms-input-placeholder {
                    color: #ccc;
                }
            }
        }
        .code {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .regType {
            width: 100%;
            margin-top: 10px;

        }
        .loginBtn {
            width: 360px;
            height: 50px;
            margin-top: 20px;
            background-color: rgb(221,225,226);
            border-radius: 8px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            span {
                font-size: 18px;
                color: #fff;
                letter-spacing: 1px;
            }
        }
        & > .active {
            background-color: #409EFF;
        }
    }
</style>
